import { html, LitElement, unsafeCSS } from "lit";
import styles from './Icon.scss?inline';
import { customElement, property } from "lit/decorators.js";
import '../Badge/Badge';

@customElement('app-icon-dumb')
export class Icon extends LitElement {
    static styles = [unsafeCSS(styles)];
    @property({ type: String }) k_badge: string | number = undefined;
    @property({ type: Boolean, reflect: true }) k_isDot: boolean = false;

    render() {
        return html`
            <slot></slot>
            <app-badge class='icon-badge' .k_value=${this.k_badge} .k_isDot=${this.k_isDot}></app-badge>
        `;
    }
}